import React from "react";
import { Bell, BellOff, BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { usePush } from "@/hooks/usePush";
import { sendTestPush } from "@/lib/apiClient";

export const PushToggle = ({ compact = false }) => {
  const p = usePush();
  if (p.loading || !p.supported || !p.configured) return null;
  const blocked = p.permission === "denied";
  const toggle = async () => {
    if (p.enabled) { await p.disable(); toast.success("Notifications off on this device"); return; }
    if (p.needsInstall) { toast.info("On iPhone, add D20 to your Home Screen first (user menu → Add D20 to home screen), then turn notifications on from the installed app.", { duration: 9000 }); return; }
    try {
      const r = await p.enable();
      if (r === "granted") toast.success("You'll be notified on this device when an invoice is handed to you or you're @mentioned");
      else toast.error("Notifications are blocked for this site — allow them in your browser settings");
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not turn notifications on"); }
  };
  const Icon = p.busy ? Loader2 : p.enabled ? BellRing : blocked ? BellOff : Bell;
  const label = p.enabled ? "Notifying this device" : blocked ? "Notifications blocked" : "Notify me here";
  return (
    <div className="flex items-center gap-1">
      <button type="button" onClick={toggle} disabled={p.busy || (blocked && !p.enabled)} data-testid="push-toggle" aria-pressed={p.enabled} title={p.enabled ? `On · ${p.devices} device${p.devices === 1 ? "" : "s"}` : "Get a notification when an invoice is handed to you or you're @mentioned"}
              className={cn("inline-flex h-9 items-center gap-1.5 rounded-full border px-3 text-xs font-medium transition-colors", p.enabled ? "border-primary/40 bg-primary/10 text-primary" : "border-border text-muted-foreground hover:text-foreground hover:bg-muted", compact && "px-2.5")}>
        <Icon className={cn("h-4 w-4", p.busy && "animate-spin")} />{!compact && <span>{label}</span>}
      </button>
      {p.enabled && !compact && (
        <button type="button" onClick={() => sendTestPush().then(() => toast.success("Test notification sent")).catch((e) => toast.error(e?.response?.data?.detail || "Could not send"))} data-testid="push-test-btn" className="text-[11px] text-muted-foreground underline-offset-2 hover:underline">Send test</button>
      )}
    </div>
  );
};
